import { CatalogNotes, ChildCatalogs } from '@/types/product-detail';
import { http } from './http.service';
import {
  SearchResultReq,
  SearchResultRes,
  DocSearchResultReq,
  CatergorySearchReq,
  CategorySearchResultRes,
  Document,
  CatalogInfo,
  SearchRetestReq,
  SearchRetestRes,
  SearchCatalogAiData,
  SearchKeywordNpiData,
} from '@/types/search-result';

class SearchResultService {
  getSearchResult = async (searchResultReq: SearchResultReq) => {
    const { countryCode, filter, language, pageNo, pageSize, persona, query } = searchResultReq;
    const params = {
      countryCode,
      language,
      filter,
      pageNo,
      pageSize,
      persona,
      query,
    };
    const response = await http.post<SearchResultRes>(`/api/search/catalog/keyword`, params);
    return response;
  };

  getSearchKeywordNpi = async ({ query }: { query: string }) => {
    const response = await http.post<SearchKeywordNpiData>('/api/search/catalog/keyword/npi', {
      query,
    });
    return response;
  };

  getSearchCatalogAi = async ({ query }: { query: string }) => {
    const response = await http.post<SearchCatalogAiData>('/api/search/catalog/ai', {
      query,
    });
    return response;
  };

  getCatalogInfo = async (catalogNumbers: string[]) => {
    const response = await http.post<CatalogInfo[]>('/api/search/catalog/info', catalogNumbers);
    return response.data;
  };

  getCatalogNotes = async (catalogNumbers: string[]) => {
    const response = await http.post<CatalogNotes[]>('/api/search/catalog/notes', catalogNumbers);
    return response;
  };

  getDocSearchResult = async (searchResultReq: DocSearchResultReq) => {
    const { documentType, page, pageSize, catalogNumber } = searchResultReq;
    const response = await http.get<Document[]>(
      `/service/document?documentType=${documentType}&pageNo=${page}&pageSize=${pageSize}&catalogNumber=${encodeURIComponent(
        catalogNumber
      )}`
    );
    return response;
  };

  getCategorySearch = async (searchResultReq: CatergorySearchReq) => {
    const { page, pageSize, categoryId, filter, countryCode, language } = searchResultReq;
    const params = {
      categoryId,
      pageNo: page,
      pageSize,
      filter,
      countryCode,
      language,
    };
    const response = await http.post<CategorySearchResultRes>('/api/search/category', params);
    return response.data;
  };

  getChildCatalogs = async (catalogNumber: string) => {
    const response = await http.post<ChildCatalogs[]>(`/api/search/catalog/child`, {
      catalogNumber,
    });
    return response.data;
  };
  getRetestSearchResult = async (searchResultReq) => {
    const response = await http.post<SearchRetestRes>('/api/search/searchAlfaRetest', searchResultReq);
    return response;
  };
}

export const searchResultService = new SearchResultService();
